// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kNH05","colMin":"styles_colMin__LcE3f"};